import { WorkspaceOverviewBlock, GroupItem } from '../types/WorkspaceOverviewTypes';

const ensureUrlProtocol = (url?: string) => {
  if (!url) return '';
  if (/^https?:\/\//i.test(url)) return url;
  return `https://${url}`;
};

export const formatContentAsMarkdown = (block: WorkspaceOverviewBlock): string => {
  const { content, block_type } = block;

  switch (block_type) {
    case 'text':
    case 'textarea':
    case 'rich_text':
      return content.value || '';

    case 'link': {
      const url = ensureUrlProtocol(content.url || content.value);
      if (!url) return '';
      const label = content.label || (content.url || content.value || '').replace(/^https?:\/\//i, '') || url;
      return `[${label}](${url})`;
    }
    
    case 'list':
      return content.items?.map(item => {
        if (typeof item === 'object' && item !== null) {
          if (item.name && item.description) {
            return `- **${item.name}**: ${item.description}`;
          }
          return `- ${JSON.stringify(item, null, 2)}`;
        }
        return `- ${item}`;
      }).join('\n') || '';
    
    case 'checklist':
      return content.items?.map((item, index) => 
        `- [${content.checked?.[index] ? 'x' : ' '}] ${item}`
      ).join('\n') || '';
    
    case 'links':
      return content.urls?.map(link => {
        const normalizedUrl = ensureUrlProtocol(link.url);
        if (!normalizedUrl) return `- ${link.label || ''}`.trim();
        return `- [${link.label || normalizedUrl.replace(/^https?:\/\//i, '')}](${normalizedUrl})`;
      }).join('\n') || '';
    
    case 'code':
      return `\`\`\`\n${content.value || ''}\n\`\`\``;
    
    case 'quote':
      return `> ${content.value || ''}`;
    
    case 'callout':
      return `**[${content.variant?.toUpperCase() || 'INFO'}]** ${content.value || ''}`;
    
    case 'group':
      return content.personas?.map((persona: GroupItem) => {
        const parts = [`### ${persona.name}`, persona.description];
        if (Array.isArray(persona.goals) && persona.goals.length) {
          parts.push(`\n**Goals:**\n${persona.goals.map((g: string) => `- ${g}`).join('\n')}`);
        }
        if (Array.isArray(persona.pain_points) && persona.pain_points.length) {
          parts.push(`\n**Pain Points:**\n${persona.pain_points.map((p: string) => `- ${p}`).join('\n')}`);
        }
        if (Array.isArray(persona.characteristics) && persona.characteristics.length) {
          parts.push(`\n**Characteristics:**\n${persona.characteristics.map((c: string) => `- ${c}`).join('\n')}`);
        }
        return parts.join('\n');
      }).join('\n\n---\n\n') || '';
    
    default:
      return content.value || '';
  }
};
